<script>
import { mapActions } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';

import VInput from '@/components/Common/VInput';
import VSelect from '@/components/Common/VSelect';

export default {
  props: {
    dealers: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    VInput,
    VSelect,
    VeeForm: Form,
    VeeField: Field,
  },
  data() {
    return {
      name: null,
      phone: null,
      email: null,
      dealer: null,
    };
  },
  setup() {
    const schema = Yup.object().shape({
      name: Yup.string().required(),
      phone: Yup.string().required(),
      email: Yup.string().email(),
      dealer: Yup.mixed().nullable(false).required(),
    });

    return {
      schema,
    };
  },
  computed: {
    formData() {
      return {
        name: this.name,
        phone: this.phone,
        email: this.email,
        dealer: this.dealer.id,
        action: 'footer-form',
        header: 'Заявка на обратный звонок',
      };
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      send: 'FormData/send',
    }),
    
    onSubmit(value, actions) {
      this.send(this.formData);

      this.togglePopup('popup-message');

      this.reset();
      setTimeout(() => {
        actions.resetForm();
      }, 1000);
    },
    reset() {
      this.name = null;
      this.phone = null;
      this.email = null;
      this.dealer = null;
    },
  },
};
</script>

<template>
  <div>
    <vee-form
      :validation-schema="schema"
      novalidate
      class="grid grid-cols-1 md:grid-cols-2 grid-rows-5 md:grid-rows-3 gap-3.5 mt-5 md:mt-10 xl:mt-12"
      @submit="onSubmit"
    >
      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="name"
      >
        <v-input
          v-model="name"
          placeholder="Введите ФИО*"
          theme="gray"
          format="name"
          name="name"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="phone"
      >
        <v-input
          v-model="phone"
          placeholder="+7 (___) ___-__-__"
          theme="gray"
          format="phone"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="email"
      >
        <v-input
          v-model="email"
          placeholder="Введите почту"
          theme="gray"
          name="e-mail"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="dealer"
      >
        <v-select
          v-model="dealer"
          :options="dealers"
          placeholder="Укажите дилерский центр*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>
      <button
        type="submit"
        class="button button_green button_big w-full md:col-span-2"
      >Отправить</button>
    </vee-form>
  </div>
</template>

